import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'modals/dialog'
import Content from './content'

const AddCompetenceRecord = props => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Modal.Header heading={formatMessage({
                id: 'action_pick_category',
                defaultMessage: 'Pick category'
            })} />
            <Modal.Body>
                <Content {...props} />
            </Modal.Body>
        </>
    )
}

export default AddCompetenceRecord
